import { fetchCartCount } from '../../api/cart';
import { setCartCount } from '../slices/cart';

/**
 * Refresh cart item count from backend and store in Redux.
 * Kept as a thunk (not in slice) to avoid circular deps with request.ts → store.
 */
export const refreshCartCount =
    (userId: string | number) =>
    async (dispatch: (action: any) => void) => {
        if (!userId || userId === '0' || userId === 0) return;
        try {
            const count = await fetchCartCount(userId);
            dispatch(setCartCount(count));
        } catch (err) {
            console.error('refreshCartCount failed', err);
        }
    };

